import React  from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import styles from './AnalyticsSectionItem.module.scss'

const AnalyticsSectionItem = ({
  title,
  route
}) => (
  <NavLink
    className={styles.item}
    activeClassName={styles.active}
    to={`/analytics/${route}`}
  >
    { title }
  </NavLink>
)

AnalyticsSectionItem.propTypes = {
  title: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired
}

export default AnalyticsSectionItem
